import axios from 'axios';

const state = () => ({
    list: [],
    take: 25,
    skip: 0,
    search: "",
    only_filter: "",
    columns: [
        {
            table: "email_templates",
            direction: "ASC",
            direction_pos: 0,
            key: "name",
            label: "name",
            setable: false,
            class: "is-2",
            display: true,
        },
        {
            table: "email_templates",
            direction: "ASC",
            direction_pos: 0,
            key: "language",
            label: "language",
            display: true,
            languageLabel: true,
        },
        {
            table: "email_templates",
            direction: "ASC",
            direction_pos: 0,
            key: "filter",
            label: "filter",
            display: true,
        },
    ],
    allLoaded: false,
    loading: true,
    loaded: false,
    addNew: false,
    infinity: {
        active: false,
    },
    workingOn: [],
    activePagination: false,
    pagination: {
        currentPage: 1,
        totalPageCount: 1,
    },
    meta: {},
    templatefilters: [],
    isSaving: false
})

const getters = {

}

const actions = {
    async load({ commit, state, rootState }, page = 1) {
        commit("isLoading", true);
        commit("skip", (page - 1) * state.take);
        if (state.allLoaded == false) {
            await axios.get(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/emailtemplates", { params: { take: state.take, skip: state.skip, activePagination: state.activePagination, table_columns: state.columns, search: state.search, only_filter: state.only_filter } }).then((response) => {
                commit("set", response.data.data);
                commit("pagination", _.get(response, "data.meta.pagination", { total: 0, take: state.take }))
            })
        }
        commit("isLoading", false);
    },
    async store({ commit, state, rootState }, data) {
        commit('isSaving', true);
        await axios.put(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/emailtemplates", data).then(response => {
            commit("unshift", response.data.data);
        })
        commit('isSaving', false);
    },
    async update({ commit, state, rootState }, data) {
        commit('isSaving', true);
        await axios.post(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/emailtemplates/" + data.id, data).then(response => {
            commit("update", response.data.data);
        })
        commit('isSaving', false);
    },
    async destroy({ commit, state, rootState }, data) {
        commit('isSaving', true);
        await axios.delete(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/emailtemplates/" + data.id).then(response => {
            commit("removeId", response.data.deleted);
        })
        commit('isSaving', false);
    },
    async getEmailtemplateFilters({ commit, state, rootState }) {
        commit("isLoading", true);
        await axios.get(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/getEmailtemplateFilters").then(response => {
            commit("setEmailtemplateFilters", response.data);
        })
        commit("isLoading", false);
    },
}

const mutations = {
    setSearch(state, search) {
        state.search = search
    },
    onlyFilter(state, filter) {
        state.only_filter = filter;
    },
    clean(state) {
        state.search = "";
        state.only_filter = "";
        state.list = [];
        state.allLoaded = false;
        state.workingOn = [];
        state.loaded = false;
    },
    set(state, list) {
        if (list == undefined || list.length <= 0) {
            state.allLoaded = true;
        }
        if (state.infinity.active == true) {
            state.list.push(...list);
        } else {
            state.list = list;
        }
    },
    unshift(state, element) {
        state.list.unshift(element);
    },
    update(state, element) {
        var index = state.list.findIndex(item => item.id == element.id);
        state.list[index] = element;
    },
    skip(state, skip) {
        state.skip = skip;
    },
    pagination(state, object) {
        state.meta = object;
        if (state.skip <= 0) {
            state.pagination.currentPage = 1;
        } else {
            state.pagination.currentPage = (state.skip / state.take) + 1;
        }
        state.pagination.totalPageCount = Math.ceil(state.meta.total / state.take);
        if (state.infinity.active == true && state.meta.total <= state.skip) {
            state.allLoaded = true;
        }
    },
    removeId(state, id) {
        var index = state.list.findIndex(item => item.id == id);
        if (index >= 0) {
            state.list.splice(index, 1);
        }
    },
    isLoading(state, status) {
        state.loading = status;
    },
    isSaving(state, status) {
        state.isSaving = status;
    },
    setEmailtemplateFilters(state, data) {
        state.templatefilters = data;
    },
    cleanTemplateFilters(state) {
        state.templatefilters = [];
    },
    updateColumn(state, column) {
        var index = state.columns.findIndex(item => item.key == column.key)
        for (let i in state.columns) {
            state.columns[i].direction_pos += 1;
        }
        if (index > -1) {
            column.direction_pos = 0;
            state.columns[index] = column;
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
    }
}
